import { Fragment, ReactElement } from 'react';
import Breadcrumbs, { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import ActionsList from './actions';

interface ResearchCitizenshipNotificationsSharedProps {
  goBackUrl?: string;
  items?: BreadcrumbItem[];
  redirectUrl?: string;
}

const ResearchCitizenshipNotificationsShared = ({
  goBackUrl,
  items,
  redirectUrl,
}: ResearchCitizenshipNotificationsSharedProps): ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={items || []} />
      <PersonSearch
        pathname={redirectUrl}
        action={ActionsList}
        addedTitle="- Registrazone cittadinanza"
        goBackUrl={goBackUrl}
      />
    </Fragment>
  );
};

ResearchCitizenshipNotificationsShared.displayName =
  'Research Citizenship Notifications Shared component';

export default ResearchCitizenshipNotificationsShared;
